import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";
import appConfig from './appConfig';

const appName = "SutterSync-UI";
const reactPlugin = new ReactPlugin();
const browserHistory = createBrowserHistory({ basename: appName });
const appInsights = new ApplicationInsights({
  config: {
    namePrefix: appName,
    enableAutoCollectConsole: true,
    enableAutoRouteTracking: true,
    connectionString: appConfig.AppInsightsConnectionString,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});

if (appConfig.AppInsightsConnectionString) {
  appInsights.loadAppInsights();

  appInsights.addTelemetryInitializer((envelope) => {
    if (envelope.tags) {
      envelope.tags['ai.cloud.role'] = appName;
    }
  });

  const originalConsoleLog = console.log;
  console.log = (...args) => {
    originalConsoleLog(...args);
    appInsights.trackTrace({ message: args.map(arg => JSON.stringify(arg)).join(' ') });
  };

  const originalConsoleError = console.error;
  console.error = (...args) => {
    originalConsoleError(...args);
    appInsights.trackException({ 
      exception: new Error(args.map(arg => JSON.stringify(arg)).join(' ')) 
    });
  };
}

export default { appInsights };